.ux-filter {
  display: block;
}

.ux-filter__remove-all {
  @include font(bold);

  align-items: center;
  background-color: transparent;
  color: $color-black;
  cursor: pointer;
  display: inline-flex;
  flex-flow: row nowrap;
  font-size: $size-text-smaller;
  justify-content: center;
  line-height: 1;
  margin-bottom: $dim-10;
  min-height: $dim-30;
  padding: 5px 0;
  position: relative;
  text-decoration: none;
  text-transform: uppercase;

  ux-icon[name="close"] {
    font-size: 10px;
    margin-left: 10px;
  }

  &::after {
    background-color: $color-black;
    bottom: 0;
    content: "";
    display: block;
    height: 1px;
    left: 0;
    position: absolute;
    transform: scaleX(0);
    transform-origin: 0 0;
    transition: transform $animationSpeed-fast ease-out;
    width: 100%;
  }

  &:hover::after {
    transform: none;
  }

  &.is-hidden {
    display: none;
  }
}
